import { render, staticRenderFns } from "./CompanyNotes.vue?vue&type=template&id=6c544f36&"
import script from "./CompanyNotes.vue?vue&type=script&lang=js&"
export * from "./CompanyNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports